// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3rUpG","dragIcon":"Choice_dragIcon__1o0PS","left":"Choice_left__30eDU","input":"Choice_input__1M-Y_"};